import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
    selector: '[appFlipCardOnClick]',
    standalone: false
})
export class FlipCardOnClickDirective implements OnInit, OnChanges, OnDestroy {


  @Input()
  flipped!: boolean;

  @Input()
  onFocus!: EventEmitter<boolean>;

  @HostBinding('class.flipped') isFlipped = false;

  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(private renderer: Renderer2,
    private elementRef: ElementRef) {
  }

  @HostListener('click') onMouseOver(): void {
    this.handleFlip();
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['flipped'] && !changes['flipped'].firstChange) {
      this.handleFlip();
    }
  }

  handleFlip(): void {
    this.isFlipped = !this.isFlipped;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
